import {
    HEADER_MY_ACCOUNT_MENU_HASH,
    HEADER_MY_ACCOUNT_OVERVIEW_MENU_HASH,
    HEADER_MY_ACCOUNT_MENU_SUPPORT_HASH,
    HEADER_CART_MENU_HASH,
    CATALOG_FILTER_TABS_HASH,
    CATALOG_FILTER_ACTIVE_TAB_HASH,
    CATALOG_FILTER_CATEGORIES_HASH
} from '../config/constants';

const firstLevel = [
    HEADER_MY_ACCOUNT_MENU_HASH,
    HEADER_CART_MENU_HASH,
    CATALOG_FILTER_TABS_HASH,
    CATALOG_FILTER_CATEGORIES_HASH
];

const secondLevel = [
    HEADER_MY_ACCOUNT_OVERVIEW_MENU_HASH,
    HEADER_MY_ACCOUNT_MENU_SUPPORT_HASH,
    CATALOG_FILTER_ACTIVE_TAB_HASH
];

const SAME = 'SAME';
const BACKWARDS = 'BACKWARDS';
const FORWARD = 'FORWARD';
/**
 * Defines if the navigation has "forward", "backwards" or "same" direction.
 * @param {string} from Navigating from hash
 * @param {string} to Navigating to hash
 */
function getNavDirection(from, to) {
    const fromFirst = firstLevel.includes(from);
    const fromSecond = secondLevel.includes(from);
    const toFirst = firstLevel.includes(to);

    if (fromFirst && toFirst) {
        return SAME;
    }
    else if (fromSecond && toFirst) {
        return BACKWARDS;
    }

    return FORWARD;
}

/**
 * This function mimics some kind of tree-like navigation structure rankin the hash values.
 * Depending on the arguments passed:
 * - navigates to the new hash
 * - replaces the current hash
 * - or goes back and replaces previous state
 *
 * TODO: check if we need the actual location.hash value for deep linking and if not, try to use only history API.
 * @param {number} back defines if to go back in history w/o any other history manipulations
 * @param {string} newHash defines the next hash to navigate to
 */
export function navigateToHash(back, newHash) {
    if (back) {
        history.go(back);

        return;
    }

    const direction = getNavDirection(window.location.hash, newHash);
    const newLocation = `${window.location.pathname}${newHash}`;

    if (direction === SAME) {
        // if user navigates from first level to first level - replace history
        history.replaceState({}, '', newLocation);
    }
    else if (direction === BACKWARDS) {
        // if user navigates from second level to first level(not it's own first level) - go back and then replace history
        history.back();
        setTimeout(() => {
            history.replaceState({}, '', newLocation);
        }, 100);
    }
    else {
        // always use pushState() instead of location.hash to support history.back() in Chrome on iOS
        history.pushState({}, '', newLocation);
    }
}

// for testing purposes
export const _testing = {
    firstLevel,
    secondLevel,
    SAME,
    BACKWARDS,
    FORWARD,
    getNavDirection
};
